<template>
  <div><div class="page-header"><h2><span class="breadcrumb-level">服务管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">宠境训练</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">教学内容管理</span></h2><el-button type="primary" @click="showDialog(false)">新增内容</el-button></div>
    <el-table :data="list" stripe v-loading="loading">
      <el-table-column label="封面" width="60"><template #default="{row}"><el-image :src="row.cover_image" style="width:36px;height:36px;border-radius:4px" fit="cover"/></template></el-table-column>
      <el-table-column label="标题" prop="title" min-width="180"/>
      <el-table-column label="分类" width="100"><template #default="{row}">{{row.category?.name||'-'}}</template></el-table-column>
      <el-table-column label="会员" width="60"><template #default="{row}"><el-tag :type="row.member_only?'warning':'info'" size="small">{{row.member_only?'仅会员':'公开'}}</el-tag></template></el-table-column>
      <el-table-column label="操作" width="180"><template #default="{row}"><el-button size="small" @click="showDialog(true,row)">编辑</el-button><el-button size="small" type="danger" @click="handleDelete(row)">删除</el-button></template></el-table-column>
    </el-table>

    <el-pagination
      v-if="pagination.total > 0"
      v-model:current-page="pagination.current_page"
      v-model:page-size="pagination.per_page"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10,20,50]"
      small
      background
      style="margin-top:16px;justify-content:flex-end"
      @current-change="fetchData"
      @size-change="fetchData"
    />
    <el-dialog v-model="dialogVisible" :title="isEdit?'编辑内容':'新增内容'" width="750px">
      <el-form ref="formRef" :model="form" :rules="{title:[{required:true,message:'请输入标题'}]}" label-width="110px">
        <el-form-item label="所属分类" prop="category_id"><el-select v-model="form.category_id" style="width:100%"><el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id"/></el-select></el-form-item>
        <el-form-item label="标题" prop="title"><el-input v-model="form.title"/></el-form-item>
        <el-form-item label="封面图"><Upload v-model="form.cover_image" :max-count="1" tip="推荐尺寸 宽 690 × 高 470 px" /></el-form-item>
        <el-form-item label="简介"><el-input v-model="form.intro" type="textarea" :rows="2" maxlength="500"/></el-form-item>
        <el-form-item label="视频">
          <div class="video-picker">
            <div v-if="form.video_url" class="video-preview-card" @click="openVideoPicker">
              <div v-if="form.video_type === 'video'" class="video-preview-wrap">
                <video :src="form.video_url" muted preload="metadata" class="video-preview-media" />
                <div class="video-badge"><el-icon size="20"><VideoCameraFilled /></el-icon></div>
              </div>
              <img v-else :src="form.video_url" class="video-preview-img" />
              <div class="video-preview-bar">
                <span class="video-preview-name">{{ form.video_name || '已选视频' }}</span>
                <button type="button" class="video-preview-replace">重新选择</button>
              </div>
            </div>
            <div v-else class="video-add" @click="openVideoPicker">
              <el-icon size="24"><Plus /></el-icon>
              <span style="margin-top:6px">选择视频</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="仅会员可见"><el-switch v-model="form.member_only"/></el-form-item>
        <el-form-item label="详情"><RichTextEditor v-model="form.content" /></el-form-item>
      </el-form>
      <template #footer><el-button @click="dialogVisible=false">取消</el-button><el-button type="primary" @click="handleSave">保存</el-button></template>
    </el-dialog>
    <MediaPicker v-model:visible="videoPickerVisible" mode="single" accept="video" title="选择视频" @confirm="handleVideoConfirm" />
  </div>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue';import { ElMessage, ElMessageBox } from 'element-plus';import RichTextEditor from '../../components/RichTextEditor.vue';import * as api from '../../api/training';import Upload from '../../components/Upload.vue';import MediaPicker from '../../components/MediaPicker.vue';
const list=ref([]);const categories=ref([]);const loading=ref(false);
const pagination = reactive({ current_page: 1, per_page: 20, total: 0, last_page: 1 });const dialogVisible=ref(false);const isEdit=ref(false);const formRef=ref(null);const videoPickerVisible=ref(false);
const form=ref({category_id:'',title:'',cover_image:'',intro:'',content:'',video_url:'',video_type:'',video_name:'',member_only:false});
const fetchData=async()=>{loading.value=true;try{const r=await api.getTrainingContents({page:pagination.current_page,per_page:pagination.per_page});list.value=r.data||[];pagination.current_page=r.pagination?.current_page||1;pagination.total=r.pagination?.total||0}catch{}finally{loading.value=false}};
const fetchCategories=async()=>{try{const r=await api.getTrainingCategories();categories.value=r.data||[]}catch{}};
const showDialog=(e,r)=>{isEdit.value=e;const base={category_id:r?.category_id||'',title:r?.title||'',cover_image:r?.cover_image||'',intro:r?.intro||'',content:r?.content||'',member_only:!!r?.member_only};if(r&&r.video_url){form.value={...base,video_url:r.video_url,video_type:'video',video_name:r.video_name||'已有视频'}}else{form.value={...base,video_url:'',video_type:'',video_name:''}};dialogVisible.value=true};
const openVideoPicker=()=>{videoPickerVisible.value=true};
const handleVideoConfirm=(item)=>{if(!item)return;form.value.video_url=item.url;form.value.video_type=item.type||'video';form.value.video_name=item.name||'';videoPickerVisible.value=false};
const handleSave=async()=>{const v=await formRef.value.validate().catch(()=>false);if(!v)return;try{if(isEdit.value){await api.updateTrainingContent(form.value.id,form.value)}else{await api.createTrainingContent(form.value)}ElMessage.success('保存成功');dialogVisible.value=false;await fetchData()}catch{}};
const handleDelete=(r)=>{ElMessageBox.confirm('确定删除？','提示').then(async()=>{await api.deleteTrainingContent(r.id);await fetchData()}).catch(()=>{})};
onMounted(async()=>{await fetchCategories();await fetchData()});
</script>
<style scoped>
.header-actions{display:flex;gap:12px;align-items:center}

/* 视频选择器（对齐 MediaList 视频卡片风格） */
.video-picker { display:inline-block }
.video-preview-card {
  position:relative; display:inline-block;
  width:200px; height:160px;
  border:1px solid #e4e7ed; border-radius:6px; overflow:hidden;
  background:#f5f5f5; cursor:pointer; vertical-align:top;
}
.video-preview-card:hover { border-color:#9E8569 }
.video-preview-wrap { position:relative; width:200px; height:120px; overflow:hidden }
.video-preview-media { width:100%; height:100%; object-fit:cover; display:block }
.video-preview-img { width:200px; height:120px; object-fit:cover; display:block }
.video-badge {
  position:absolute; top:50%; left:50%; transform:translate(-50%,-50%);
  color:rgba(255,255,255,.95); pointer-events:none;
  background:rgba(0,0,0,.35); border-radius:50%; width:40px; height:40px;
  display:flex; align-items:center; justify-content:center;
}
.video-preview-bar {
  position:absolute; bottom:0; left:0; right:0;
  display:flex; align-items:center; gap:4px;
  padding:4px 8px; background:rgba(0,0,0,.5); height:40px; box-sizing:border-box;
}
.video-preview-name {
  flex:1; font-size:12px; color:#fff;
  overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
}
.video-preview-replace {
  background:none; border:1px solid rgba(255,255,255,.6); color:#fff;
  font-size:11px; padding:2px 6px; border-radius:3px; cursor:pointer; flex-shrink:0;
}
.video-preview-replace:hover { background:rgba(255,255,255,.15) }
.video-add {
  display:inline-flex; flex-direction:column; align-items:center; justify-content:center;
  width:200px; height:120px; border:1px dashed #d9d9d9; border-radius:6px;
  cursor:pointer; color:#8c939d; transition:border-color .2s, color .2s;
}
.video-add:hover { border-color:#409eff; color:#409eff }
</style>
